export * from './product-price.component'
